import { createSelector } from 'reselect';

export const appSelector = state => state.app;

export const changeBrowserModalVisibilitySelector = createSelector(
  appSelector,
  state => state.show_change_browser_modal
);
